import { renderPlpPage } from './product-listing-page';

renderPlpPage();
import('./product-listing-page/components/PLPBuilder/lazyInit').then((module) => module.renderPlpBuilderBanner());
